import { Ref } from 'vue';

export default function useTrackLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<TrackLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config || !JUE.traffic?.TrackManager) return;

  const trackLayer = new JUE.traffic.TrackManager(mapInstance);

  const unwatch = watchEffect(() => {
    if (!Array.isArray(layerInfo.value.config.data)) return;
    const trackList = layerInfo.value.config.data.map((track: TrackGeometry, index: number) => {
      const { id, type, path } = track;
      const pathList = path.map((point: PathPoint) => ({
        ...point,
        position: new JUE.LatLng(point.position.lat, point.position.lng),
      }));
      return {
        id: id ? id : `${index}`,
        type,
        path: pathList,
      };
    });

    trackLayer.set(trackList);
  });

  trackLayer.unmount = (): void => {
    trackLayer?.destroy();
    unwatch();
  };

  return trackLayer;
}
